function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

import { instrumentMethod } from '../tools/instrumentMethod';
import { monitor } from '../tools/monitor';
import { Observable } from '../tools/observable';
import { clocksNow } from '../tools/utils/timeUtils';
import { normalizeUrl } from '../tools/utils/urlPolyfill';
var fetchObservable;
export function initFetchObservable() {
  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }

  return fetchObservable;
}
export function resetFetchObservable() {
  fetchObservable = undefined;
}

function createFetchObservable() {
  return new Observable(function (observable) {
    if (!window.fetch) {
      return;
    }

    var _instrumentMethod = instrumentMethod(window, 'fetch', function (call) {
      return beforeSend(call, observable);
    }, {
      computeHandlingStack: true
    }),
        stop = _instrumentMethod.stop;

    return stop;
  });
}

function beforeSend(_ref, observable) {
  var parameters = _ref.parameters,
      onPostCall = _ref.onPostCall,
      handlingStack = _ref.handlingStack;

  var _parameters = _slicedToArray(parameters, 2),
      input = _parameters[0],
      init = _parameters[1];

  var methodFromParams = init && init.method;

  if (methodFromParams === undefined && input instanceof Request) {
    methodFromParams = input.method;
  }

  var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
  var url = input instanceof Request ? input.url : normalizeUrl(String(input));
  var startClocks = clocksNow();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url,
    handlingStack: handlingStack
  };
  observable.notify(context); // Those properties can be changed by observable subscribers

  parameters[0] = context.input;
  parameters[1] = context.init;
  onPostCall(function (responsePromise) {
    return afterSend(observable, responsePromise, context);
  });
}

function afterSend(observable, responsePromise, startContext) {
  var context = startContext;

  function reportFetch(partialContext) {
    context.state = 'resolve';
    Object.assign(context, partialContext);
    observable.notify(context);
  }

  responsePromise.then(monitor(function (response) {
    reportFetch({
      response: response,
      responseType: response.type,
      status: response.status,
      isAborted: false
    });
  }), monitor(function (error) {
    var _a, _b;

    reportFetch({
      status: 0,
      isAborted: ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || error instanceof DOMException && error.code === DOMException.ABORT_ERR,
      error: error
    });
  }));
}